import { AntButton } from '@/common/ant-components/AntButton';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Select } from 'antd';
import React, { useState } from 'react';

/**
 * CustomSelect component for searchable and sortable select input.
 *
 * @param {Object} props - Component properties.
 * @param {Array} props.options - Array of options for the select input.
 * @returns {JSX.Element} - Rendered CustomSelect component.
 */
const CustomSelect = ({
  options,
  onAddClick,
  showAddButton = true,
  filterSort,
  defaultValue,
  selectRef = null,
  loading = false,
  onAddClickSalesAgent,
  selectLoading = false,
  ...restProps
}) => {
  const [items, setItems] = useState(options);
  const handleAddItem = (item) => {
    setItems([...items, item]);
  };
  return (
    <Select
      showSearch
      allowClear
      className="username"
      style={{ width: '100%' }}
      placeholder="Search to Select"
      optionFilterProp="children"
      defaultValue={defaultValue}
      ref={selectRef}
      filterOption={(input, option) =>
        option?.label?.toLowerCase()?.includes(input?.toLowerCase())
      }
      loading={loading || selectLoading}
      filterSort={
        filterSort ??
        ((optionA, optionB) =>
          (optionA?.label ?? '')
            .toLowerCase()
            .localeCompare((optionB?.label ?? '').toLowerCase()))
      }
      popupRender={(menu) => (
        <>
          {menu}
          {showAddButton !== false && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '8px',
                borderTop: '1px solid #e8e8e8',
                background: 'none',
              }}
            >
              <AntButton
                icon={<PlusOutlined />}
                style={{ width: '100%' }}
                onClick={() => {
                  onAddClick && onAddClick(handleAddItem);
                  onAddClickSalesAgent && onAddClickSalesAgent(handleAddItem);
                }}
              >
                Add
              </AntButton>
            </div>
          )}
        </>
      )}
      virtual={true}
      options={options}
      {...restProps}
    />
  );
};

export default CustomSelect;

// export const globalSearch = (data, searchTerm) => {
//   if (!searchTerm) {
//     return data // Return original data if searchTerm is empty
//   }
//   return data?.filter((item) =>
//     Object.values(item).some((value) =>
//       value?.toString().toLowerCase().includes(searchTerm.toLowerCase()),
//     ),
//   )
// }

/**
 * Filters data based on a search term, including nested subGroups.
 *
 * @param {Array} data - The original data array to be filtered.
 * @param {string} searchTerm - The term to search for in the data.
 * @returns {Array} - Filtered data array matching the search term.
 */
export const globalSearch = (data, searchTerm) => {
  if (!searchTerm) {
    return data; // Return original data if searchTerm is empty
  }

  /**
   * Recursively searches through items and their subGroups.
   *
   * @param {Array} items - The items to search through.
   * @returns {Array} - Filtered items matching the search term.
   */
  const search = (items) => {
    return items
      ?.map((item) => {
        const hasChildren = item.subGroups && item.subGroups.length > 0;
        const matches = Object.values(item).some((value) =>
          value?.toString().toLowerCase().includes(searchTerm.toLowerCase()),
        );

        if (hasChildren) {
          const filteredChildren = search(item.subGroups);
          if (filteredChildren.length > 0 || matches) {
            return {
              ...item,
              subGroups: filteredChildren,
            };
          }
        }

        return matches ? item : null;
      })
      .filter((item) => item !== null);
  };

  return search(data);
};
